/** Normalize MRI description lines that contain literal HTML break tags. */
export function splitDescriptionLines(lines: string[]): string[] {
  return lines.flatMap((line) =>
    line
      .replace(/<br\s*\/?>/gi, "\n")
      .split(/\n+/)
      .map((s) => s.trim())
      .filter(Boolean)
  );
}

/** Join fragmented MRI description lines into readable paragraphs. */
export function formatDescriptionParagraphs(lines: string[]): string[] {
  const normalized = splitDescriptionLines(lines);
  if (normalized.length === 0) return [];

  const paragraphs: string[] = [];
  let buffer = "";

  for (const line of normalized) {
    if (buffer) {
      buffer = buffer.endsWith("-")
        ? `${buffer.slice(0, -1)}${line}`
        : `${buffer} ${line}`;
    } else {
      buffer = line;
    }

    if (/[.!?]["']?\s*$/.test(line)) {
      paragraphs.push(buffer.replace(/\s+/g, " ").trim());
      buffer = "";
    }
  }

  if (buffer.trim()) {
    paragraphs.push(buffer.replace(/\s+/g, " ").trim());
  }

  return paragraphs;
}
